"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseIndexSettingsConfig = void 0;
const defaultAlgoliaIndex_config_1 = require("../defaultAlgoliaIndex.config");
const schemaName_1 = require("../schemaName");
exports.baseIndexSettingsConfig = {
    schemaName: schemaName_1.SchemaName.page,
    settings: (language) => (Object.assign(Object.assign(Object.assign({}, defaultAlgoliaIndex_config_1.defaultAlgoliaIndexConfig), defaultAlgoliaIndex_config_1.defaultPageFieldConfig), (0, defaultAlgoliaIndex_config_1.defaultIndexLanguageConfig)(language)))
};
